// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ChevronUp = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ChevronUp = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ChevronUp = _exports.ChevronUp = function ChevronUp(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.8361 13.1638L9.99887 6.3241L3.16732 13.1639C2.7678 13.5635 2.1671 13.4955 1.83528 13.1639C1.50346 12.8323 1.45076 12.2264 1.83611 11.8397L9.33493 4.33408C9.69224 3.96692 10.2967 3.96924 10.6614 4.33404L18.1645 11.8404C18.5039 12.1797 18.5634 12.7649 18.1645 13.1638C17.796 13.5323 17.1879 13.5155 16.8361 13.1638Z",
      fill: "currentColor"
    }));
  };
});
